import React, { useEffect, useState } from "react";
import { Button, MenuItem } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuList from "@material-ui/core/MenuList";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import RootRef from "@material-ui/core/RootRef";

const StyleMenu = withStyles(theme => ({
  root: {
    width: "100%",
    boxShadow: "5px 10px 18px #888888",
    borderRadius: "4px",
    marginTop: "2px"
  }
}))(MenuList);

const StyledButton = withStyles(() => ({
  root: {
    backgroundColor: "#FFFFFF",
    border: "1px solid #DADCE0",
    borderRadius: "8px",
    boxShadow: "0px 10px 20px rgba(173,174,174,0.25)",
    fontFamily: "Roboto",
    fontWeight: "bold",
    fontSize: "16px",
    padding: "16px",
    width: "100%",
    whiteSpace: "nowrap",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-start"
  },
  selected: {
    backgroundColor: "#000"
  }
}))(Button);

export default function ButtonMenu(props) {
  const [anchor, setAnchor] = useState(null);
  const [menuWidth, setMenuWidth] = useState(null);
  const [open, setOpen] = useState(false);

  const menuRef = React.createRef();
  const buttonRef = React.createRef();

  const handleClose = id => {
    if (props.handleSelection) {
      props.handleSelection(id);
    }
    setOpen(false);
  };

  const handleClick = event => {
    if (props.items && props.items.length > 1) {
      setOpen(true);
    } else if (props.items && props.items.length === 1) {
      handleClose(props.items[0].id);
    }
  };

  useEffect(() => {
    if (props.items && props.items.length > 1 && menuRef.current && buttonRef.current) {
      let widest = 0;
      menuRef.current.querySelectorAll("li span.button-menu-calc").forEach(node => {
        if (node.offsetWidth > widest) {
          widest = node.scrollWidth;
        }
      });
      let buttonNeededWidth = 0;
      [...buttonRef.current.querySelectorAll("span.button-menu-calc")].forEach(node => {
        buttonNeededWidth = buttonNeededWidth + node.offsetWidth;
      });
      const newMenuWidth = widest;
      const newButtonWidth = buttonNeededWidth;
      if (open) {
        setMenuWidth((newMenuWidth > newButtonWidth) ? newMenuWidth + 66 : newButtonWidth + 66);
      } else {
        setMenuWidth("auto");
      }
    }
  }, [setMenuWidth, menuRef, buttonRef, props.items, open]);

  useEffect(() => {
    const body = document.getElementsByTagName("body")[0];
    const closeOnBodyClick = e => {
      if (open) {
        setOpen(false);
      }
    };
    body.addEventListener("click", closeOnBodyClick, []);

    return () => {
      body.removeEventListener("click", closeOnBodyClick);
    };
  }, [open, setAnchor]);

  const selectedId = props.selected;
  let selectedItem;
  if (props.items) {
    selectedItem = props.items.filter(item => item.id === selectedId)[0];
  }

  const nameStyles = { fontSize: "12px", color: "#DADCE0", fontFamily: "Work Sans", fontWeight: "600" };
  const buttonStyles = {};
  const labelStyles = {};
  let sideElement = (<span />);
  if (selectedItem && props.items.length > 1) {
    labelStyles.marginRight = "25px";
    sideElement = (<span style={nameStyles}>{selectedItem.name}</span>);
  } else if (props.items && props.items.length > 1) {
    sideElement = (<ExpandMoreIcon />);
  }

  if (selectedItem) {
    buttonStyles.backgroundColor = "#0F9AD6";
    buttonStyles.color = "#FFFFFF";
  }

  return (
    <div style={{ position: "relative", width: menuWidth || "auto" }}>
      <RootRef rootRef={buttonRef}>
        <StyledButton style={buttonStyles} variant="contained" onClick={(props.handleClick) ? props.handleClick : handleClick}>
          <span className="button-menu-calc" style={labelStyles}>{props.name}</span>
          <span style={{ maxHeight: "22px" }} className="button-menu-calc">{sideElement}</span>
        </StyledButton>
      </RootRef>
      <RootRef rootRef={menuRef}>
        <Popper keepMounted placement="bottom-start" style={{ visibility: (!open) ? "hidden" : "" }} className="one-hundred" open={open} anchorEl={anchor} transition disablePortal>
          <Paper>
            <StyleMenu
              elevation={0}
              getContentAnchorEl={null}
              anchorEl={anchor}
            >
              {props.items && props.items.map(item => (
                <MenuItem
                  data-item-id={item.id}
                  onClick={() => {
                    handleClose(item.id);
                  }}
                >
                  <span className="button-menu-calc">{item.name}</span>
                </MenuItem>
              ))}
            </StyleMenu>
          </Paper>
        </Popper>
      </RootRef>
    </div>
  );
}
